export type FileFormatGroupId = 'images' | 'documents' | 'spreadsheets' | 'pdf';

export interface FileFormatGroup {
  id: FileFormatGroupId;
  title: string;
  extensions: string[];
  mimeTypes: string[];
}

export const FILE_FORMAT_GROUPS: FileFormatGroup[] = [
  {
    id: 'images',
    title: 'Bilder (gif/png/jpg)',
    extensions: ['.gif', '.png', '.jpg', '.jpeg'],
    mimeTypes: ['image/gif', 'image/png', 'image/jpeg'],
  },
  {
    id: 'documents',
    title: 'Dokumenter (doc/docx)',
    extensions: ['.doc', '.docx'],
    mimeTypes: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  {
    id: 'spreadsheets',
    title: 'Regneark (xls/xlsx/csv)',
    extensions: ['.xls', '.xlsx', '.csv'],
    mimeTypes: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
    ],
  },
  {
    id: 'pdf',
    title: 'PDF',
    extensions: ['.pdf'],
    mimeTypes: ['application/pdf'],
  },
];
